import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { PhonePipe } from './pipes/phone.pipe';
import { SafePipe } from './pipes/SafePipe.pipe';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { DragDropModule } from '@angular/cdk/drag-drop';
@NgModule({
  declarations: [SafePipe, PhonePipe],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, DragDropModule],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SafePipe,
    PhonePipe,
    NzTableModule,
    NzButtonModule,
    NzIconModule,
    NzSelectModule,
    NzInputModule,
    NzInputNumberModule,
    NzTagModule,
    NzSkeletonModule,
    NzModalModule,
    NzDropDownModule,
    NzTabsModule,
    NzPopconfirmModule,
    NzSpaceModule,
    NzBadgeModule,
    NzDescriptionsModule,
    NzAvatarModule,
    NzListModule,
    NzCardModule,
    NzFormModule,
    NzCheckboxModule,
    NzDatePickerModule,
    NzToolTipModule,
    NzSwitchModule,
    NzCollapseModule,
    NzSpinModule,
    NzEmptyModule,
    NzAlertModule,
    NzDrawerModule,
    DragDropModule,
  ],
  providers: [NzModalService],
})
export class SharedModule {}
